import { getStoredInvestmentOfficeId } from 'core/storage/authSessionStorage';

export const getInvestmentOfficeId = () => {
  const investmentOfficeId = getStoredInvestmentOfficeId();
  return String(investmentOfficeId ?? '');
};
